import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectQuotationState = (state: RootState) => state.quotation;

const selectQuotationCategories = createSelector(
  selectQuotationState,
  (state) => state.quotationCategories
);

const selectTemplateList = createSelector(
  selectQuotationState,
  (state) => state.templateList
);

const selectProductOptions = createSelector(
  selectQuotationState,
  (state) => state.productOptions
);

const selectTotalAmount = createSelector(
  selectQuotationState,
  (state) => state.totalAmount
);

export const selectors = {
  selectTemplateList,
  selectProductOptions,
  selectQuotationCategories,
  selectTotalAmount
};
